<h2 class="DTX_CONTENT_TITLE">
    {{ getTitle() }}
</h2>
